var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"text main-text"},[_vm._v("欢迎使用 "+_vm._s(this.$project.projectName))])])}
var staticRenderFns = []

export { render, staticRenderFns }